import { render, staticRenderFns } from "./KYCSummary.vue?vue&type=template&id=760b477a"
import script from "./KYCSummary.vue?vue&type=script&lang=js"
export * from "./KYCSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports